/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from "react";
import { Order } from "app-types/";

type UseTableContextProps<TModel, TFilterData> = {
    data: TModel[] | undefined;
    filterFunction: (items: TModel[], filterData: TFilterData) => TModel[];
}

export const useTableContext = <TModel, TFilterData>({ data, filterFunction }: UseTableContextProps<TModel, TFilterData>) => {
    const [visibleData, setVisibleData] = useState<TModel[]>([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [orderBy, setOrderBy] = useState('');
    const [order, setOrder] = useState<Order>('asc');
    const [filterData, setFilterData] = useState<TFilterData>({} as TFilterData);
    const handleSort = useCallback(
        (property: string) => {
            const isAsc = orderBy === property && order === 'asc';
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(property);
        },
        [order, orderBy]
    );
    const handlePageChange = (_: any, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    useEffect(() => {
        const processEntities = (entity: any) => {
            if (orderBy === 'user') {
                return `${entity.user?.firstName} ${entity.user?.lastName}`;
            }
            if (orderBy === 'product') {
                return entity.product?.name;
            }
            return null;
        };
        setVisibleData([]);
        const filteredProducts = filterFunction(data ?? [], filterData).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).sort((a: TModel, b: TModel) => {
            return (order === 'asc'
                ? (processEntities(a) ?? a[orderBy as keyof TModel] ?? '') > (processEntities(b) ?? b[orderBy as keyof TModel] ?? '')
                : (processEntities(a) ?? a[orderBy as keyof TModel] ?? '') < (processEntities(b) ?? b[orderBy as keyof TModel] ?? '')) ? 1 : -1;
        }) as TModel[];
        setVisibleData(filteredProducts);
    }, [data, filterData, order, orderBy, page, rowsPerPage]);
    useEffect(() => {
        setOrderBy('name');
    }, []);

    return { visibleData, page, rowsPerPage, order, orderBy, handlePageChange, handleChangeRowsPerPage, filterData, setFilterData, handleSort };
}